export default {
  default: [
    {
      path: "/messages",
      name: "messages.index",
      component: () => import("@/modules/messages/views/MessagesInboxView.vue")
    },
    {
      path: "/messages/:id",
      name: "messages.show",
      component: () => import("@/modules/messages/views/MessagesShowView.vue")
    }
  ]
};
